export default __webpack_public_path__ + "static/media/unknown.bc7df4ad.svg";